"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaButtonMobile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const CtaButton_1 = require("./CtaButton");
const Styled = styled_components_1.default.div `
	width: 100%;
	height: ${(p) => p.theme.navHeight}px;
	.cta {
		width: 100%;
		height: 100%;
		text-align: center;
		margin: 0;
	}

	&.topNav {
		.cta {
			padding: 6px 10px;
			${(p) => p.theme.breakpoints.down("xs")} {
				padding: 4px 6px;
			}
			span {
				font-weight: 500;
				letter-spacing: -0.25px;
				width: fit-content;
				min-width: initial;

				${(p) => p.theme.breakpoints.down("xs")} {
					font-size: 10px;
					letter-spacing: -0.5px;
					width: fit-content;
					white-space: initial;
				}
			}
		}
	}
`;
const CtaButtonMobile = (_a) => {
    var { hide, position } = _a, props = __rest(_a, ["hide", "position"]);
    if (hide)
        return null;
    /**
     * Currently the dropdown is only supported on mobile when in 'topNav' position.
     */
    return (react_1.default.createElement(Styled, { className: position || "" },
        react_1.default.createElement(CtaButton_1.CtaButton, Object.assign({}, props, { dropdownDisabled: position !== "topNav" }))));
};
exports.CtaButtonMobile = CtaButtonMobile;
//# sourceMappingURL=CtaButtonMobile.js.map